<template>
  <div>
    <ak-type-input hideLabel v-model="data.state" :field="options" />
  </div>
</template>
<script>
import Bus from '@/assets/js/eventBus'
export default {
  syncProps: ['value'],
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object // 当前field对象
  },
  data () {
    return {
      data: {
        state: ''
      },
      options: {
        name: 'status',
        note: '状态',
        type: 'Select',
        items: {
          'paid': '已支付',
          'completed': '已完成'
        }
      }
    }
  },

  mounted () {
    Bus.$on('reset', this.reset)
  },
  beforeDestroy () {
    Bus.$off('reset')
  },
  methods: {
    filterQuery () {
      if (this.data.state) {
        this._value = this.data.state
      } else {
        this._value = null
      }
      // if (this._value) {
      return this._value
      // }
    },
    setValue () {
      this._value = null // 不会报错
    },
    async search (filters) {
    },
    reset () {
      this.data.state = ''
    }

  }
}
</script>

<style>

</style>
